const compactLocationPulseActions = () => {
    document
        .querySelectorAll('.ff-discovery-location-list a > span:last-child')
        .forEach((action) => {
            if ((action.textContent ?? '').trim() !== 'View →') {
                return;
            }

            action.textContent = '→';
            action.setAttribute('aria-hidden', 'true');
            action.setAttribute('title', 'Open festival');
        });
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', compactLocationPulseActions, {
        once: true,
    });
} else {
    compactLocationPulseActions();
}
